export default class WapiPresetSettings {
  constructor() {
    this.coordinate_order = [1, 0];
  }
}
